import { FieldProps } from '@rjsf/utils'
import { Box, Typography } from '@mui/material';

export const ImageField = function (props: FieldProps) {
    const src: string | undefined = (props.schema as any)['cl-image'];

    if (!src) {
        return <Typography variant="body2" color="text.secondary">{props.schema.title ?? 'Image'}</Typography>;
    }

    return (
        <Box>
            <Box component="img" src={src} alt={props.schema.title ?? 'image'} sx={{ maxWidth: '100%', display: 'block' }} />
        </Box>
    );
};
